import { atom } from 'infrastructure/state/jotai.wrapper'
import { getAPIRequest } from 'infrastructure/api'
import { loadable } from 'jotai/utils'
import {
  useAtomWithErrorNotification,
  WithErrorResult,
} from 'shared/ui/GlobalDialog'

interface ISubject {
  subject_id: number
  subject_name: string
  branches: { subject_id: number; subject_name: string }[]
}

interface ISubjectResponse {
  subjects: ISubject[]
}

type SubjectWithId = ISubject & { id: number }

const subjectsResponseAtom = loadable(
  atom(async () => {
    return getAPIRequest<ISubjectResponse>('/api/subjects')
  }),
)

export const subjectsByIdWithErrorAtom = atom<
  WithErrorResult<Record<number, SubjectWithId>>
>((get) => {
  const resp = get(subjectsResponseAtom)
  if (resp.state === 'hasData') {
    const mapped = resp.data.subjects.reduce<Record<string, SubjectWithId>>(
      (acc, subject) => {
        acc[subject.subject_id] = { ...subject, id: subject.subject_id }
        return acc
      },
      {},
    )

    return {
      result: mapped,
      error: undefined,
    }
  }
  if (resp.state === 'hasError') {
    return {
      result: undefined,
      error: String(resp.error),
    }
  }
  return {}
})

export function useSubjectsById() {
  return useAtomWithErrorNotification(
    { errorTitle: 'Error Retrieving Subjects' },
    subjectsByIdWithErrorAtom,
  )
}

const subjectsByNameAtom = atom<WithErrorResult<Record<string, SubjectWithId>>>(
  (get) => {
    const resp = get(subjectsResponseAtom)
    if (resp.state === 'hasData') {
      const mapped = resp.data.subjects.reduce<Record<string, SubjectWithId>>(
        (acc, subject) => {
          acc[subject.subject_id] = { ...subject, id: subject.subject_id }
          return acc
        },
        {},
      )
      return {
        result: mapped,
        error: undefined,
      }
    }
    if (resp.state === 'hasError') {
      return {
        result: undefined,
        error: String(resp.error),
      }
    }
    return {}
  },
)

export function useSubjectsByName() {
  return useAtomWithErrorNotification(
    { errorTitle: 'Error Retrieving Subjects' },
    subjectsByNameAtom,
  )
}
